import React, { useEffect } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import Select from "react-select";
import cx from "classnames";

const SimpleValue = ({
  options,
  value,
  isMulti,
  optionValue,
  children,
  ...rest
}) => {
  const hasValue = value !== undefined && value !== null && value !== "";
  value =
    hasValue && !isMulti
      ? options.find((option) => option[optionValue] === value)
      : value;
  return children({ options, isMulti, value, ...rest });
};

const SelectS1 = (props) => {
  const {
    isClearable,
    isDisabled,
    disableOptions,
    className,
    label,
    isMulti,
    placeholder,
    options,
    field,
    optionLabel,
    optionValue = "id",
    size,
    form: { touched, errors, setFieldValue, setFieldTouched },
    isSearchable,
    menuPlacement,
    initialValue,
    handleChange = () => {},
  } = props;

  const classes = cx(
    "form-field",
    touched[field.name] && errors[field.name] && "form-field--error",
    (field.value !== undefined && field.value !== null && field.value !== "") &&
      "form-field--active",
    className
  );

  const getSizeHeight = () => {
    switch (size) {
      case "default":
        return "48px";
      case "small":
        return "38px";
      case "large":
        return "58";
      default:
        return "48px";
    }
  };
  const getSizeRadius = () => {
    switch (size) {
      case "default":
        return "10px";
      case "small":
        return "5px";
      case "large":
        return "15px";
      default:
        return "10px";
    }
  };
  const getSizeFont = () => {
    switch (size) {
      case "default":
        return "16px";
      case "small":
        return "14px";
      case "large":
        return "18px";
      default:
        return "16px";
    }
  };

  const customStyle = {
    control: (provided) => ({
      ...provided,
      cursor: "pointer",
      borderColor: "rgba(0,0,0,.1)",
      border:
        touched[field.name] && errors[field.name]
          ? "1px solid red"
          : "1px solid #e1e2e6",
      minHeight: getSizeHeight(),
      borderRadius: getSizeRadius(),
    }),
    container: (provided) => ({
      ...provided,
      minHeight: getSizeHeight(),
      minWidth: "150px",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: getSizeHeight(),
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#d2daec",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: getSizeFont(),
      fontFamily: "Inter",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: getSizeFont(),
      fontFamily: "Inter",
      whiteSpace: "nowrap",
      color: "#bfbfbf",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
  };

  useEffect(() => {
    if (initialValue) {
      setFieldValue(field.name, initialValue);
    }
  }, []);

  return (
    <div className={classes}>
      {label && <div className="form-field__label">{label}</div>}
      <SimpleValue
        id={field.name}
        name={field.name}
        onChange={(option) => {
          if (isMulti) {
            setFieldValue(field.name, option);
          } else {
            setFieldValue(field.name, get(option, optionValue, undefined));
          }
          handleChange(option);
        }}
        onBlur={() => setFieldTouched(field.name, true)}
        options={options}
        optionValue={optionValue}
        getValue={(option) => option[optionValue]}
        getOptionLabel={(option) => option[optionLabel]}
        getOptionValue={(option) => option[optionValue]}
        placeholder={placeholder}
        styles={customStyle}
        value={field.value}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isSearchable={isSearchable}
        isClearable={isClearable}
        menuPlacement={menuPlacement}
        isOptionDisabled={(option) =>
          disableOptions
            .reduce((prev, curr) => [...prev, curr.id], [])
            .includes(option.id)
        }
      >
        {(simpleProps) => <Select {...simpleProps} />}
      </SimpleValue>
      {touched[field.name] && errors[field.name] && (
        <div className="form-field__error">
          <span>{errors[field.name]}</span>
        </div>
      )}
    </div>
  );
};

SelectS1.propTypes = {
  label: PropTypes.string.isRequired,
  optionLabel: PropTypes.string,
  optionValue: PropTypes.string,
  options: PropTypes.array.isRequired,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  menuPlacement: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(["default", "large", "small"]),
};

SelectS1.defaultProps = {
  optionLabel: "name",
  optionValue: "id",
  isSearchable: false,
  isClearable: false,
  menuPlacement: "bottom",
  className: "",
  label: "",
  disableOptions: [],
  size: "default",
};

export default SelectS1;
